
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import { avatars, avatars_active_status } from '../../index.const';
import intro_logo from '_images/logo-intro.png';

export default function (app) {
  app
    .controller('ApplicationCtrl', ApplicationCtrl);

  function ApplicationCtrl($log, $transitions, $state, $rootScope, Session) {
    'ngInject';

    $rootScope.introLogo = intro_logo;
    
    $rootScope.$avatars = {
      default: avatars,
      actived: avatars_active_status
    };
    
    $transitions.onSuccess({},function (t) {
      let data = Session.get();
      let state = t.targetState();

      if (!Session.enabled){
        return false
      }

      if(state.name === 'login'){
        return false;
      }

      
      
      if( _.isUndefined(data.stages)){
        $state.go('login')
      } else {
        $rootScope.$currentUser = data.user;
      }
     });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/controllers/application.controller.js